export const aprilPayIndustryConstants = {
  BASE_PATH: '/v1/april_pay_industries',
};
